export default __webpack_public_path__ + "images/362ea7abb042c584adb5fc3c699b8b54-random.svg";